export const messages = {
  en: {
    sysDocumentManage: {
      queryCondition: 'Query Conditions',
      hide: 'Hide',
      more: 'More',
      inputDocCode: 'Please enter document code',
      inputDocTitle: 'Please enter document title',
      inputDocId: 'Please enter document ID',
      query: 'Query',
      documentInfo: 'Document Information',
      add: 'Add',
      docTitle: 'Document Title',
      docCode: 'Document Code',
      docId: 'Document ID',
      createTime: 'Create Time',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete'
    },
    addSysDocumentView: {
      title: 'Add Document',
      docTitle: 'Title',
      docTitlePlaceholder: 'Required, please enter title',
      docTitleRequired: 'Document title cannot be empty',
      docTitleMaxLength: 'Document title cannot exceed 200 characters',
      docCode: 'Document Code',
      docCodePlaceholder: 'Required, please enter document code',
      docCodeRequired: 'Document code cannot be empty',
      docCodeMaxLength: 'Document code cannot exceed 200 characters',
      docContent: 'Content',
      docContentPlaceholder: 'Required, please enter content',
      docContentRequired: 'Document content cannot be empty',
      cancel: 'Cancel',
      submit: 'Submit',
      saveSuccess: 'Document saved successfully'
    },
    editSysDocumentView: {
      title: 'Edit Document',
      docTitle: 'Title',
      docTitlePlaceholder: 'Required, please enter title',
      docTitleRequired: 'Document title cannot be empty',
      docTitleMaxLength: 'Document title cannot exceed 200 characters',
      docCode: 'Document Code',
      docCodePlaceholder: 'Required, please enter document code',
      docCodeRequired: 'Document code cannot be empty',
      docCodeMaxLength: 'Document code cannot exceed 200 characters',
      docContent: 'Content',
      docContentPlaceholder: 'Required, please enter content',
      docContentRequired: 'Document content cannot be empty',
      docIdRequired: 'Document ID cannot be empty',
      cancel: 'Cancel',
      save: 'Save',
      updateSuccess: 'Document updated successfully'
    },
    deleteSysDocument: {
      title: 'Confirm Operation',
      confirmDelete: 'Are you sure to delete this document?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      deleteSuccess: 'Document deleted successfully',
      deleteFailed: 'Failed to delete document'
    }
  },
  zh: {
    sysDocumentManage: {
      queryCondition: '查询条件',
      hide: '隐藏',
      more: '更多',
      inputDocCode: '请输入文档编码',
      inputDocTitle: '请输入文档名称',
      inputDocId: '请输入文档ID',
      query: '查询',
      documentInfo: '文档信息',
      add: '添加',
      docTitle: '文档标题',
      docCode: '文档编码',
      docId: '文档ID',
      createTime: '创建时间',
      operation: '操作',
      edit: '修改',
      delete: '删除'
    },
    addSysDocumentView: {
      title: '添加文档',
      docTitle: '标题',
      docTitlePlaceholder: '必填，请填写标题',
      docTitleRequired: '文档标题不能为空',
      docTitleMaxLength: '文档标题不能超过200位',
      docCode: '文档编码',
      docCodePlaceholder: '必填，请填写文档编码',
      docCodeRequired: '文档编码不能为空',
      docCodeMaxLength: '文档编码超过200位',
      docContent: '信息内容',
      docContentPlaceholder: '必填，请输入公告内容',
      docContentRequired: '活动内容不能为空',
      cancel: '取消',
      submit: '提交',
      saveSuccess: '文档保存成功'
    },
    editSysDocumentView: {
      title: '修改文档',
      docTitle: '标题',
      docTitlePlaceholder: '必填，请填写标题',
      docTitleRequired: '文档标题不能为空',
      docTitleMaxLength: '文档标题不能超过200位',
      docCode: '文档编码',
      docCodePlaceholder: '必填，请填写文档编码',
      docCodeRequired: '文档编码不能为空',
      docCodeMaxLength: '文档编码超过200位',
      docContent: '信息内容',
      docContentPlaceholder: '必填，请输入公告内容',
      docContentRequired: '活动内容不能为空',
      docIdRequired: '文档ID不能为空',
      cancel: '取消',
      save: '保存',
      updateSuccess: '文档修改成功'
    },
    deleteSysDocument: {
      title: '请确认您的操作',
      confirmDelete: '确定删除文档',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '文档删除成功',
      deleteFailed: '文档删除失败'
    }
  }
}